import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { Unidade } from "./../../../models/unidade";
import { InscricaoService } from "./../../../services/inscricao.service";
import { CustomValidator } from "../../shared/validators/custom.validator";

import { Util } from "../../shared/util";
import { MessageService } from "primeng/components/common/messageservice";
import { WebPage } from "../../shared/web-page";
import { UnidadeService } from "../../shared/services/unidade.service";
import { FaseService } from "../../fase/fase.service";
import { forEach } from "@angular/router/src/utils/collection";

@Component({
  templateUrl: "./valida-dados.component.html",
})
export class ValidaDadosComponent extends WebPage implements OnInit {
  errorMessage: string;

  idFase;
  unidades;

  isEmpresarial = false;
  isCpfValido: boolean;
  empresaNaoCadastrada = false;
  rendaInvalida = false;
  camposBloqueados = false;

  get unidade() {
    return this.form.get("unidade");
  }
  get idUnidade() {
    return this.form.get("idUnidade");
  }
  get cpf() {
    return this.form.get("cpf");
  }
  get cnpj() {
    return this.form.get("cnpj");
  }
  get rendaIndividual() {
    return this.form.get("rendaIndividual");
  }
  get dataNascimento() {
    return this.form.get("dataNascimento");
  }

  public form: FormGroup;
  constructor(
    private fb: FormBuilder,
    messageService: MessageService,
    private inscricaoService: InscricaoService,
    private unidadeService: UnidadeService,
    private router: Router,
    private route: ActivatedRoute,
    private faseService: FaseService,
  ) {
    super(messageService);

    this.form = this.fb.group({
      idUnidade: ["", Validators.required],
      cpf: ["", [Validators.maxLength(14), Validators.required]],
      cnpj: ["", [Validators.maxLength(18)]],
      rendaIndividual: [""],
      dataNascimento: ["", Validators.required],
    });

    this.route.paramMap.subscribe(
      (params) => (this.idFase = params.get("idFase"))
    );
  }

  ngOnInit() {
    this.isLoading = true;
    this.unidadeService
      .getUnidadesParticipantesInscricoesAbertasByFase(this.idFase)
      .finally(() => (this.isLoading = false))
      .subscribe(
        (unidades) => {
          this.unidades = unidades;
        },

        (error) => this.gerenciaErro(error)
      );

    this.faseService.getFull(this.idFase).subscribe((edital)=> {
      if(edital === null){
        this.gerenciaErro("Edital não encontrado.");
      }else{
        this.isEmpresarial = edital.tipoEdital !== null && edital.tipoEdital.nome === "Pessoa Jurídica";

        if(this.isEmpresarial) this.bloquearCampos();
      }
    }, (e)=>{
      this.gerenciaErro(e);
    })
  }

  bloquearApenasEmpresa(){
    this.f.cnpj.disable();
  }

  bloquearCampos(limpar = false){
    this.camposBloqueados =true;
    this.f.cnpj.disable();
    this.f.dataNascimento.disable();
    this.f.rendaIndividual.disable();
    this.f.idUnidade.disable();
    if(limpar){
      this.f.cnpj.setValue('');
      this.f.dataNascimento.setValue('');
      this.f.rendaIndividual.setValue('');
      this.f.idUnidade.setValue('');
    }
  }

  desbloquearCampos(){
    this.camposBloqueados = false;
    this.f.cnpj.enable();
    this.f.dataNascimento.enable();
    this.f.rendaIndividual.enable();
    this.f.idUnidade.enable();
  }

  get f(){
    return this.form.controls;
  }


  validaCpf() {
    if (!Util.isCpf(Util.limpaCpf(this.cpf.value))) {
      this.messageService.add({
        severity: "error",
        summary: "Atenção",
        detail: "CPF inválido.",
      });
      this.cpf.setValue("");
      if(this.isEmpresarial){
        this.bloquearCampos(true);
        this.unidades = [];
      }
    }else{
      if(this.isEmpresarial){
        const cpfLimpo = Util.limpaCpf(this.cpf.value);
        this.inscricaoService.validaRecomendacao(cpfLimpo, this.idFase).subscribe((v :any)=>{
          if(v == null){
            this.bloquearCampos(true);
            this.unidades = [];
            this.messageService.add({ severity: 'error', summary: 'Falha na Validação', detail: 'O CPF informado não foi indicado por nenhuma empresa para este edital. Para continuar com a inscrição, é necessário que o CPF esteja vinculado a uma empresa participante.' });
          } else{
            this.form.controls.cnpj.setValue(v.empresa.cnpj);

            //se for do tipo empresa, setar as unidades como as unidades disponíveis para a empresa
            v.empresa.vagas.forEach((vaga) =>{
              vaga.vagaUnidades.forEach((vu)=> {
                if(vu.unidade !== undefined && vu.unidade !== null){
                  this.unidades.push(vu.unidade);
                }
              })
            })
            
            this.desbloquearCampos();
            this.bloquearApenasEmpresa();
            
          }
        })
      }
      
    }
  }

  validaCnpjDeTransporte() {
    if (this.cnpj.value === "") {
      return;
    }

    this.isLoading = true;
    this.inscricaoService
      .validaCnpjDeTransporte(Util.limpaCnpj(this.cnpj.value))
      .finally(() => (this.isLoading = false))
      .subscribe(
        (resultado) => {
          this.empresaNaoCadastrada = false;

          if (resultado.toString() === "invalido") {
            this.messageService.add({
              severity: "error",
              summary: "Atenção",
              detail: "CNPJ inválido.",
            });
            this.cnpj.setValue("");
            this.empresaNaoCadastrada = true;
          }
        },
        (error) => this.gerenciaErro(error)
      );
  }

  validaSalario() {
    const value = this.rendaIndividual.value.toString();
    // this.rendaInvalida = value === "0,00" || value === "";
  }

  submit() {
    const cpfLimpo = Util.limpaCpf(this.cpf.value);
    const cnpjLimpo = Util.limpaCnpj(this.cnpj.value);
    const dataNascimento = this.dataNascimento.value;

    this.isLoading = true;
    // this.inscricaoService.validaDados(cnpjLimpo, dataNascimento, cpfLimpo, this.idFase)
    this.inscricaoService
      .validaDadosNova(cnpjLimpo, dataNascimento, cpfLimpo, this.idFase)
      .finally(() => (this.isLoading = false))
      .subscribe(
        (resultado) => {
          if (resultado === "validamaior") {
            this.messageService.add({
              severity: "error",
              summary: "Atenção",
              detail: "A idade mínima de participação é de 21 anos!",
            });
            return;
          }

          if (resultado === "validaempresa") {
            this.messageService.add({
              severity: "error",
              summary: "Atenção",
              detail: "Empresa não cadastrada.",
            });
            return;
          }

          if (resultado === "validacandidato") {
            this.messageService.add({
              severity: "error",
              summary: "Atenção",
              detail: "Candidato já inscrito!",
            });
            return;
          }

          const data: string = this.dataNascimento.value;
          localStorage.setItem(
            "dadosPrincipais",
            JSON.stringify({
              idFase: this.idFase,
              idUnidade: this.idUnidade.value,
              cpf: this.cpf.value,
              cnpj: this.cnpj.value,
              salario: this.rendaIndividual.value,
              dataNascimento:
                data.substr(6, 4) +
                "-" +
                data.substr(3, 2) +
                "-" +
                data.substr(0, 2),
              razaoSocial: resultado,
            })
          );
          this.router.navigate(["/inscricao-form/" + this.idFase]);
        },
        (error) => this.gerenciaErro(error)
      );
  }

  buscarEmpresaParticipanteUnidade(evento: any) {
    if (!evento.target.value) {
      return;
    }

    const cnpj = evento.target.value.replace(/\D/g, "");

    this.inscricaoService.getEmpresaParticipanteUnidade(cnpj).subscribe((x) => {
      if (x) {
        // this.unidade.setValue(`${x.nomeUnidade}/${x.siglaUf} ${x.tipologia}`);
        this.idUnidade.setValue(x.idUnidade);
      } else {
        // this.unidade.setValue("");
        this.idUnidade.setValue("");
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/candidato/valida-dados/valida-dados.component.ts